import React from "react";

const TechnicalTraining = () => {
    return <div>TechnicalTraining</div>;
};

export default TechnicalTraining;
